import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinearBackgroundDirective } from './linear-gradient.directive';
import { DebounceClickDirective } from './debounce-click';
import { ReadMoreDirective } from './read-more.directive';
import { NoSpecialCharDirective, NoInputSpecialCharDirective, MaxLengthDirective, NumberDirective } from './only-number.directive';

@NgModule({
  declarations: [
    LinearBackgroundDirective,
    DebounceClickDirective,
    ReadMoreDirective,
    NoSpecialCharDirective,
    NoInputSpecialCharDirective,
    MaxLengthDirective,
    NumberDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    LinearBackgroundDirective,
    DebounceClickDirective,
    ReadMoreDirective,
    NoSpecialCharDirective,
    NoInputSpecialCharDirective,
    MaxLengthDirective,
    NumberDirective
  ]
})
export class DirectivesModule { }
